export type SessionMode = 'legacy' | 'dual' | 'cookie';

export const SESSION_MODE: SessionMode = 'legacy';
